import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { CAAction } from '../actions';
import { StaffCustomers } from '../actions/index';
import * as selectors from '../reducers/index';
import { MembersService } from '@careapp-group/ng-sdk-v2-new';

@Injectable()
export class StaffCustomerEffects {
  @Effect()
  fetchStaffCustomers = this.actions$.pipe(
    ofType(StaffCustomers.REQUEST_ALL),
    withLatestFrom(
      this.store.select(selectors.getSelectedId(selectors.MEMBERS)),
      this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS)),
      this.store.select(selectors.getSelectedId(selectors.TENANTS))
    ),
    switchMap(([action, memberId, organisationId, tenantId]) =>
      this.membersService
        .listMemberCustomers({
          id: memberId,
          organisationId: organisationId ?? undefined,
          tenantId: tenantId ?? undefined,
        })
        .pipe(
          map((res) => StaffCustomers.ResponseSuccessAllAction(res)),
          catchError((err) => of(StaffCustomers.ResponseFailAllAction(err)))
        )
    )
  );

  constructor(
    private store: Store<any>,
    private actions$: Actions<CAAction>,
    private membersService: MembersService
  ) {}
}
